module.exports = __webpack_public_path__ + "media/images/category/feature/aoj_b/logo-aoj-ja-951b7aa9744d317d8f57a0a15738b8e6.svg";